module.exports = __webpack_public_path__ + "media/images/pc/visit_reserve/flow-confirm-1d26ff057b9d581e5162988f38ba3829.png";